import { useCallback } from "react";
import {
  useDisableProductPriceHistory,
  useEnableProductPriceHistory,
} from "../mutations/useStatusProducPriceHistoryToggle.mutation";

export const useProductPriceHistoryStatusToggle = () => {
  const disableMutation = useDisableProductPriceHistory();
  const enableMutation = useEnableProductPriceHistory(); // Assuming you have a similar mutation for enabling

  const handleEnable = useCallback(
    (id: string) => {
      enableMutation.mutate(id);
    },
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => {
      disableMutation.mutate(id);
    },
    [disableMutation],
  );

  return {
    handleDisable,
    isDisabling: disableMutation.isPending,
    handleEnable,
    isEnabling: enableMutation.isPending,
  };
};
